import createStore from 'react-waterfall'

import middleware from './middleware'
import initialState from './state'
import actionsCreators from './actions'

const config = { initialState, actionsCreators }

export const { Provider, connect, actions } = createStore(config, [middleware])



// WEBPACK FOOTER //
// ./assets/js/store/index.js